import React, { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import { useNotification } from "@hooks/useNotification";
import { useReduxSelector } from "@hooks/useReduxSelector";

import Button from "@components/tailwindComponents/Button";
import CheckboxSimple from "@components/tailwindComponents/CheckboxSimple";

import { cloneValue } from "@helpers/_functions";

import SideModalMultiple from "../components/SideModalMultiple";
import EmployeTaskItem from "./EmployeTaskItem";
import ModalManageTask from "./ModalManageTask";

export default function EmployeTaskList(props) {
  const tasks = props.employeProtocol.tasks;
  const { t } = useTranslation("beginEnd.protocol");
  const [openSideModal, setOpenSideModal] = useState(false);
  const [openSideModalMultiple, setOpenSideModalMultiple] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const { showInfo } = useNotification();

  const employerList = useReduxSelector(
    (state) => state.evaluation.eligibleEvaluator.list
  );

  function onManageTaskClicked(task) {
    setSelectedTask(task);
    setOpenSideModal(true);
  }

  const validTasks = useMemo(
    () =>
      tasks?.filter(
        (_task) =>
          (["simple_validation", "answer"].includes(_task.expectedResultType) ||
            ([
              "document_sending",
              "upload_request",
              "signature_request"
            ].includes(_task.expectedResultType) &&
              _task?.targetFolder)) &&
          _task.status !== "completed"
      ),
    [tasks]
  );

  const onSelect = async (e, task) => {
    // e.preventDefault()
    let _tasks = cloneValue(selectedTasks);

    if (
      ["simple_validation", "answer"].includes(task.expectedResultType) ||
      (["document_sending", "upload_request", "signature_request"].includes(
        task.expectedResultType
      ) &&
        task?.targetFolder)
    ) {
      if (_tasks?.some((o) => o._id === task._id)) {
        _tasks = _tasks?.filter((o) => o._id !== task._id);
      } else {
        _tasks.push(task);
      }

      setSelectedTasks(_tasks);
    } else {
      return showInfo(
        "Impossible de sélectionner cette tâche, Il est nécessaire de la paramétrer avant de l'attribuer à un utilisateur"
      );
    }
  };

  const onSelectAll = () => {
    if (selectedTasks?.length) {
      setSelectedTasks([]);
    } else {
      setSelectedTasks(validTasks);
    }
  };

  return (
    <div className="arh-space-y-4">
      <div className="arh-my-5 arh-flex arh-items-center arh-justify-between">
        <div className="arh-flex arh-items-center arh-space-x-4">
          <h4 className="arh-m-0 arh-font-poppins arh-text-sm arh-font-semibold arh-text-darkColor">
            {t("Tâches à effectuer")}
          </h4>
          <div className="arh-flex arh-w-[2.75rem] arh-items-center arh-justify-center arh-rounded-[3.5rem] arh-bg-cardGreen arh-py-1 arh-font-poppins arh-text-xs arh-font-semibold arh-text-btnGreen">
            {tasks.length}
          </div>
        </div>
        <Button
          onClick={() => setOpenSideModalMultiple(!openSideModalMultiple)}
          disabled={selectedTasks?.length ? false : true}
          className="!arh-w-fit"
        >
          {t("Assigner")}
        </Button>
      </div>
      <div className="arh-h-[75vh] arh-w-full desktop-little:arh-h-[70vh] ">
        <table className="arh-w-full arh-table-fixed arh-overflow-y-auto  arh-font-poppins">
          <thead>
            <tr className="arh-bg-greyColor">
              <th className=" arh-w-[2%]">
                <div className=" arh-flex arh-items-center">
                  <CheckboxSimple
                    id="selectAllTasks"
                    name="Tasks"
                    onClick={onSelectAll}
                    checked={
                      Boolean(validTasks?.length) &&
                      validTasks?.length === selectedTasks?.length
                    }
                    haveHover={false}
                  />
                </div>
              </th>

              <th className="arh-w-[20%] arh-bg-greyColor arh-px-[1.125rem] arh-py-[10px] arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Tâches à réaliser")}
              </th>
              <th className="arh-w-[20%] arh-px-[1rem] arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Résultat attendu")}
              </th>
              <th className="arh-w-[15%]  arh-px-[1rem] arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Détails/consignes")}
              </th>
              <th className="arh-w-[20%]  arh-px-[1rem] arh-text-center arh-text-xs arh-font-semibold arh-text-darkColor">
                {t("Assigné à")}
              </th>
              <th className="arh-w-[13%] arh-px-[1rem] arh-text-xs arh-font-semibold  arh-text-darkColor">
                {t("Etat")}
              </th>
              <th className="arh-w-[10%] arh-px-[1rem] arh-text-xs arh-font-semibold  arh-text-darkColor"></th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => (
              <EmployeTaskItem
                key={task._id}
                task={task}
                onManageTaskClicked={() => onManageTaskClicked(task)}
                onSelect={onSelect}
                checked={selectedTasks?.some(
                  (_task) => _task?._id === task._id
                )}
              />
            ))}
          </tbody>
        </table>
      </div>

      <ModalManageTask
        isOpen={openSideModal}
        onClose={() => setOpenSideModal(false)}
        selectedTask={selectedTask}
        employeFolders={props.employeFolders}
        taskList={tasks}
      />

      <SideModalMultiple
        employeDropdown={employerList}
        openSideModal={openSideModalMultiple}
        closeSideModal={() => setOpenSideModalMultiple(false)}
        tasks={selectedTasks}
        setSelectedTasks={setSelectedTasks}
      />
    </div>
  );
}
